(() => {
  'use strict';
  function appendBloom(element) {
    const emblem = document.querySelector('.kimo-bloom-icon');
    if (emblem) element.append(emblem.cloneNode(true));
  }
  document.querySelectorAll('[data-pdf-download]').forEach(link => {
    const source = link.href;
    link.addEventListener('click', async event => {
      event.preventDefault();
      if (link.dataset.loading) return;
      const artworkCard = link.classList.contains('editorial-art-card');
      const viewer = window.open('', '_blank');
      if (viewer) {
        viewer.opener = null;
        viewer.document.title = 'Opening process book';
        viewer.document.body.textContent = 'Preparing your process book…';
      }
      link.dataset.loading = 'true';
      if (artworkCard) link.setAttribute('aria-busy', 'true');
      else link.textContent = 'Preparing PDF…';
      try {
        const response = await fetch(source);
        if (!response.ok) throw new Error('PDF unavailable');
        const data = await response.json();
        let encoded = data.base64;
        if (Array.isArray(data.parts)) {
          const segments = await Promise.all(data.parts.map(async part => {
            const partUrl = new URL(part, source);
            partUrl.search = new URL(source).search;
            const response = await fetch(partUrl);
            if (!response.ok) throw new Error('PDF part unavailable');
            return (await response.json()).base64;
          }));
          encoded = segments.join('');
        }
        const raw = atob(encoded);
        if (!raw.startsWith('%PDF-')) throw new Error('Invalid PDF');
        const bytes = Uint8Array.from(raw, character => character.charCodeAt(0));
        const url = URL.createObjectURL(new Blob([bytes], {type:'application/pdf'}));
        if (viewer) viewer.location.replace(url + '#view=FitH&zoom=page-width');
        else {
          const ready = document.createElement('a');
          ready.href = url; ready.target = '_blank'; ready.rel = 'noopener';
          ready.textContent = 'Your PDF awaits — open it';
          ready.className = 'process-download';
          link.parentElement.querySelector('[data-pdf-ready]')?.remove();
          ready.dataset.pdfReady = ''; link.after(ready);
        }
        if (!artworkCard) link.textContent = 'Open PDF';
      } catch (error) {
        if (viewer) viewer.close();
        if (!artworkCard) link.textContent = 'Retry opening PDF';
      } finally { delete link.dataset.loading; link.removeAttribute('aria-busy'); }
    });
  });
  const root = (window.KIMO_ROOT || '/').replace(/\/?$/, '/');
  let cartBusy = false;
  let cartRevision = 0;
  const approvedImageCatalog = JSON.parse(document.getElementById('kimo-approved-image-catalog')?.textContent || '[]');
  function approvedCartImage(item) {
    if ((item.handle || '').startsWith('kimo-reset-') || ['men-s-box-hoodie', 'premium-heavyweight-long-sleeve-shirt'].includes(item.handle)) return item.image;
    if ((item.handle || '').endsWith('-canvas-print')) {
      const key = item.handle.slice(0, -'-canvas-print'.length);
      const canvasImage = document.querySelector('[data-piece-key="canvas-' + key + '"] .shop-product-image');
      return canvasImage?.currentSrc || canvasImage?.src || approvedImageCatalog.find(entry => entry.key === item.handle)?.url || item.image;
    }
    const identity = (item.handle + '-' + item.product_title).toLowerCase().replace(/[^a-z0-9]+/g, '-');
    let match;
    if (identity.includes('limited-edition-lower') || (identity.includes('so-much-lower') && (identity.includes('limited') || identity.includes('amethyst')))) {
      match = approvedImageCatalog.find(entry => entry.key === 'so-much-lower-limited');
    } else if (identity.includes('kimo-basic-logo') || identity.includes('kimo-logo')) {
      match = approvedImageCatalog.find(entry => entry.key === 'kimo-basic-logo-t-o1');
    } else {
      match = approvedImageCatalog.find(entry => identity.includes(entry.key));
    }
    if (!match) match = approvedImageCatalog.find(entry => entry.productId && String(entry.productId) === String(item.product_id));
    const style = (item.product_title + '-' + (item.variant_title || '')).toLowerCase();
    if (match && !match.key.includes('washed-tee') && !match.key.includes('limited') && (style.includes('1745') || style.includes('washed'))) {
      match = approvedImageCatalog.find(entry => entry.key === match.key + '-washed-tee') || match;
    }
    return match?.url || item.image;
  }
  function text(tag, value, className) {
    const el = document.createElement(tag); el.textContent = value;
    if (className) el.className = className; return el;
  }
  function money(cents, currency) {return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency || 'USD'}).format(cents/100);}
  function customerVariantTitle(title) {
    if (!title || title === 'Default Title') return '';
    const parts = (title || '').split(' / ');
    if (parts.length < 3) return title || '';
    const garment = parts[2].includes('1745') || parts[2].includes('Washed tee') ? 'Washed tee' : parts[2].includes('3901') || parts[2].includes('Fleece crewneck') ? 'Fleece crewneck' : 'Garment-dyed tee';
    return `${garment} · ${parts[0]} · ${parts[1]}`;
  }
  async function request(path, options) {
    if(options?.method==='POST'){
      cartRevision++;
      const section=document.querySelector('#kimo-cart')?.closest('.shopify-section')?.id.replace('shopify-section-','');
      if(section&&/cart\/(change|update)\.js/.test(path)){
        if(options.body instanceof FormData){options.body.set('sections',section);options.body.set('sections_url',root+'cart');}
        else{const body=JSON.parse(options.body);body.sections=[section];body.sections_url=root+'cart';options={...options,body:JSON.stringify(body)};}
      }
    }
    const response = await fetch(root + path, {...options, cache:'no-store', headers:{Accept:'application/json', ...(options?.headers || {})}});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
    return result;
  }
  document.addEventListener('click',event=>{if(event.target.closest('[data-kimo-shop-pay][aria-disabled="true"]')){event.preventDefault();event.stopImmediatePropagation();}},true);
  const purchaseForms = new Set();
  function updateCart(cart) {
    purchaseForms.forEach(form => {
      const id = form.dataset.addedVariant;
      if (id && !cart.items.some(item => String(item.variant_id) === id)) {
        delete form.dataset.addedVariant;
        form.querySelector('[data-variant-select]').dispatchEvent(new Event('change'));
      }
    });
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = cart.item_count;});
    document.querySelectorAll('[data-cart-content]').forEach(container => {
      if(container.closest('#kimo-cart')){
        const section=container.closest('.shopify-section')?.id.replace('shopify-section-','');
        const html=cart.sections?.[section];
        if(html){const doc=new DOMParser().parseFromString(html,'text/html');const replacement=doc.querySelector('#kimo-cart [data-cart-content]');if(replacement){container.replaceChildren(...replacement.childNodes);document.dispatchEvent(new Event('kimo:cart-rendered'));return;}}
        // Keep the current cart intact if section rendering fails; recover with a real reload.
        if(cart.sections){location.reload();return;}
        return;
      }
      container.replaceChildren();
      if (!cart.item_count) {
        container.append(text('p','Your cart awaits its first piece.','shop-muted'));
        const link=text('a','Explore the collection ','shop-detail-link');appendBloom(link);link.href=root+'#reset-collection';container.append(link);return;
      }
      const form=document.createElement('form');form.action=root+'cart';form.method='post';
      cart.items.forEach(item => {
        const row=text('div','','cart-row');
        const img=document.createElement('img');const imageUrl=approvedCartImage(item);if(imageUrl) img.src=imageUrl;img.alt=item.product_title;img.width=80;img.height=80;row.append(img);
        const details=document.createElement('div');const link=text('a',item.product_title);link.href=item.url;details.append(link);const variantTitle=customerVariantTitle(item.variant_title);if(variantTitle)details.append(text('p',variantTitle,'shop-muted'));
        const remove=text('button','Remove','shop-detail-link shop-remove');remove.type='button';remove.dataset.removeKey=item.key;details.append(remove);row.append(details);
        const label=text('label','Quantity ');const qty=document.createElement('input');qty.type='number';qty.min='0';qty.name='updates[]';qty.value=item.quantity;qty.setAttribute('aria-label','Quantity for '+item.product_title);label.append(qty);row.append(label,text('span',money(item.final_line_price,cart.currency)));form.append(row);
      });
      const summary=text('div','','cart-summary');
      (cart.cart_level_discount_applications || []).forEach(discount => {
        const saving=text('p',discount.title+' ','cart-discount');
        saving.append(text('strong','−'+money(discount.total_allocated_amount,cart.currency)));
        summary.append(saving);
      });
      const subtotal=text('p','Subtotal ');subtotal.append(text('strong',money(cart.total_price,cart.currency)));summary.append(subtotal,text('p','Free standard US shipping. International and express rates at checkout. Applicable taxes are shown before payment.','shop-muted'));
      const actions=text('div','','cart-actions');const update=text('button','Update cart','shop-button shop-button-outline');update.type='submit';update.name='update';const checkout=text('button','Checkout','shop-button');checkout.type='submit';checkout.name='checkout';actions.append(update,checkout);summary.append(actions);form.append(summary);container.append(form);
    });
  }
  const drawer = document.getElementById('kimo-cart-drawer');
  let cartTrigger = null;
  let drawerClosing = false;
  async function closeCartDrawer() {
    if (!drawer?.open || drawerClosing) return;
    drawerClosing = true;
    drawer.classList.add('is-closing');
    await Promise.allSettled(drawer.getAnimations().map(animation => animation.finished));
    drawer.close();drawer.classList.remove('is-closing');drawerClosing = false;
  }
  if (drawer) {
    document.querySelectorAll('.nav-cart').forEach(link => {
      link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','kimo-cart-drawer');
      link.addEventListener('click', async event => {
        event.preventDefault();cartTrigger=link;
        if (!drawer.open) drawer.showModal();
        document.body.classList.add('cart-drawer-open');
        drawer.querySelector('[data-cart-close]').focus({preventScroll:true});
        try {const revision=cartRevision;const cart=await request('cart.js');if(revision===cartRevision&&!cartBusy)updateCart(cart);}
        catch {drawer.querySelector('[data-cart-status]').textContent='Could not refresh your cart. Open the full cart to review it.';}
      });
    });
    drawer.querySelector('[data-cart-close]').addEventListener('click',closeCartDrawer);
    drawer.addEventListener('cancel',event=>{event.preventDefault();closeCartDrawer();});
    drawer.addEventListener('click',event=>{if(event.target===drawer){const box=drawer.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right)closeCartDrawer();}});
    drawer.addEventListener('close',()=>{document.body.classList.remove('cart-drawer-open');cartTrigger?.focus({preventScroll:true});});
    drawer.addEventListener('click',async event=>{
      const explore=event.target.closest('a');
      if(!explore || !explore.href.endsWith('#reset-collection'))return;
      event.preventDefault();await closeCartDrawer();
      if(document.getElementById('reset-collection'))document.getElementById('reset-collection').scrollIntoView({behavior:'smooth'});
      else window.location.assign(explore.href);
    });
    drawer.addEventListener('submit',async event=>{
      if(event.submitter?.name==='checkout')return;
      event.preventDefault();if(cartBusy)return;cartBusy=true;
      const status=drawer.querySelector('[data-cart-status]');
      try{updateCart(await request('cart/update.js',{method:'POST',body:new FormData(event.target)}));status.textContent='Cart updated.';}
      catch(error){status.textContent=error.message;}
      finally{cartBusy=false;}
    });
  }
  function bindPurchaseForm(form) {
    if (!form || purchaseForms.has(form)) return;
    purchaseForms.add(form);
    const card=form.closest('[data-shop-card]') || form.closest('[data-launch-purchase-slot]');
    const select=form.querySelector('[data-variant-select]');const button=form.querySelector('[data-add-button]');const status=form.querySelector('.shop-status');
    if (!select.options.length) {
      select.disabled = true;
      button.disabled = true;
      button.textContent = 'Coming soon';
      status.textContent = 'Available options will appear with the release.';
      form.addEventListener('submit', event => event.preventDefault());
      return;
    }
    const options = [...select.options];
    if (options.every(option => option.dataset.garment && option.dataset.color && option.dataset.size)) {
      const choices = document.createElement('div');
      choices.className = 'kimo-choice-grid';
      const fields = {};
      for (const [key, labelText] of [['garment', 'Garment'], ['color', 'Color'], ['size', 'Size']]) {
        const label = document.createElement('label');
        label.textContent = labelText;
        const field = document.createElement('select');
        field.setAttribute('aria-label', `Choose ${labelText.toLowerCase()}`);
        label.append(field);
        choices.append(label);
        fields[key] = field;
      }
      select.before(choices);
      select.hidden = true;
      const originalLabel = form.querySelector(`label[for="${select.id}"]`);
      if (originalLabel) originalLabel.hidden = true;
      const unique = values => [...new Set(values)];
      const fill = (field, values, preferred) => {
        field.replaceChildren(...unique(values).map(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          return option;
        }));
        if (unique(values).includes(preferred)) field.value = preferred;
      };
      const current = select.selectedOptions[0];
      fill(fields.garment, options.map(option => option.dataset.garment), current.dataset.garment);
      const sync = changed => {
        const garment = fields.garment.value;
        const garmentOptions = options.filter(option => option.dataset.garment === garment);
        fill(fields.color, garmentOptions.map(option => option.dataset.color), changed === 'garment' ? '' : fields.color.value || current.dataset.color);
        const colorOptions = garmentOptions.filter(option => option.dataset.color === fields.color.value);
        fill(fields.size, colorOptions.map(option => option.dataset.size), changed === 'garment' || changed === 'color' ? '' : fields.size.value || current.dataset.size);
        const chosen = colorOptions.find(option => option.dataset.size === fields.size.value);
        if (chosen) { select.value = chosen.value; select.dispatchEvent(new Event('change')); }
      };
      fields.garment.addEventListener('change', () => sync('garment'));
      fields.color.addEventListener('change', () => sync('color'));
      fields.size.addEventListener('change', () => sync('size'));
      sync('initial');
    }
    select.addEventListener('change',()=>{const choice=select.selectedOptions[0];const productImage=card.querySelector('.shop-product-image');const price=card.querySelector('[data-price]:not(option)');if(price)price.textContent=choice.dataset.price;delete form.dataset.addedVariant;button.classList.remove('is-added');status.classList.remove('is-success');button.disabled=choice.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to cart';if(productImage && !card.hasAttribute('data-model-cover')){productImage.removeAttribute('srcset');productImage.hidden=!choice.dataset.image;if(choice.dataset.image)productImage.src=choice.dataset.image;}status.textContent=productImage && !choice.dataset.image?'Image unavailable for this selection.':'';form.dispatchEvent(new Event('kimo:cart-state'));});
    select.dispatchEvent(new Event('change'));
    card.removeAttribute('data-model-cover');
    form.addEventListener('submit',async event=>{event.preventDefault();if(cartBusy || button.disabled)return;cartBusy=true;button.disabled=true;button.textContent='Adding…';button.setAttribute('aria-busy','true');status.classList.remove('is-success');status.textContent='';form.dispatchEvent(new Event('kimo:cart-state'));let added=false;
      try {await request('cart/add.js',{method:'POST',body:new FormData(form)});added=true;form.dataset.addedVariant=select.value;updateCart(await request('cart.js'));status.classList.add('is-success');status.textContent='Added to your cart.';}
      catch(error){status.textContent=added?'Added. Open your cart to review it.':error.message;}
      finally{cartBusy=false;button.removeAttribute('aria-busy');button.classList.toggle('is-added',added);button.disabled=added || select.selectedOptions[0].dataset.available!=='true';button.textContent=added?'Added':button.disabled?'Sold out':'Add to cart';form.dispatchEvent(new Event('kimo:cart-state'));}
    });
  }
  document.querySelectorAll('.kimo-product-form').forEach(bindPurchaseForm);
  document.addEventListener('kimo:purchase-ready', event => bindPurchaseForm(event.detail));
  document.addEventListener('click', async event => {
    const button=event.target.closest('[data-remove-key]');if(!button)return;event.preventDefault();if(cartBusy)return;
    cartBusy=true;button.disabled=true;button.setAttribute('aria-busy','true');const label=button.textContent;button.textContent='Removing…';const scope=button.closest('[data-cart-section]')||drawer;const status=scope?.querySelector('[data-cart-status]');if(status)status.textContent='Updating cart…';const controls=[...(scope?.querySelectorAll('button,input,[data-kimo-shop-pay]')||[])];const disabled=controls.map(control=>control.disabled);controls.forEach(control=>{control.disabled=true;control.setAttribute('aria-disabled','true');});
    try{updateCart(await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.removeKey,quantity:0})}));if(status)status.textContent='Cart updated.';}
    catch(error){if(status)status.textContent=error.message;button.textContent=label;button.disabled=false;}finally{cartBusy=false;button.removeAttribute('aria-busy');controls.forEach((control,i)=>{control.disabled=disabled[i];control.removeAttribute('aria-disabled');});}
  });
})();
